<template>
    <div>

        <div v-if="doorCheckDoorLoading">
            <div class="row">
                <div class="col-md-12 text-center pt-5 pb-5 mt-5 pb-5">
                    <i class="fa fa-circle-notch fa-spin fa-10x fa-fw" aria-hidden="true"></i>
                </div>
            </div>
        </div>

        <div v-if="doorCheckDoorFound === false && doorCheckDoorLoading === false">
            <div class="row pb-4">
                <div class="col-md-8">
                    <h2 class="page-header-title">Sorry...</h2>
                </div>
            </div>
            <div class="widget">
                <div class="widget-body">
                    <p>The door could not be found. Please check the URL and try again.</p>
                    <p> <router-link to="/">Return Home</router-link></p>
                </div>
            </div>
        </div>

        <div v-if="doorCheckDoor">

        <div class="row pb-4">
            <div class="col-md-10">
                <h2 class="page-header-title">
                    <router-link to="/">
                        Door Inspections</router-link>
                    &raquo;
                    <router-link :to="{ name: 'door-check-view', params: {action: 'view', id: doorCheck.site_door_check_id} }">
                        {{ doorCheck.document_id }} | {{ doorCheck.document_title }}
                    </router-link>
                    &raquo;
                    {{ doorCheckDoor.door_id }} | {{ doorCheckDoor.barcode }}        </h2>
            </div>
            <div class="col-md-2">
                <router-link :to="{ name: 'door-check-edit-door', params: {id: parseInt(doorCheckDoor.site_door_check_door_id)} }" class="btn btn-outline-secondary btn-square btn-lg pull-right">
                    Edit Door
                </router-link>
            </div>
        </div>

        <div class="widget" v-if="dbName !== 'jpfire' && sitePlan">
            <div class="widget-header bordered no-actions d-flex align-items-center">
                <h3>Door Location</h3>
            </div>
            <div class="widget-body">
                <site-plan-marker-view
                    v-bind:markerData="markerData"
                ></site-plan-marker-view>
            </div>
        </div>


        <div class="widget">
            <div class="widget-header bordered no-actions d-flex align-items-center">
                <h3>
                    Door Details        </h3>
            </div>
            <div class="widget-body">
                <table class="table table-bordered">
                    <tbody>
                    <tr>
                        <td><strong>Door ID</strong></td>
                        <td>{{ doorCheckDoor.door_id }}</td>
                    </tr>
                    <tr>
                        <td>
                            <strong v-if="dbName !== 'jpfire' && dbName !== 'qfpc'">Identifier</strong>
                            <strong v-else>Barcode</strong>
                        </td>
                        <td>{{ doorCheckDoor.barcode }}</td>
                    </tr>
                    <tr v-if="dbName !== 'jpfire' && dbName !== 'qfpc'">
                        <td><strong>Door Status</strong></td>
                        <td>{{ doorCheckDoor.door_status }}</td>
                    </tr>
                    <tr v-if="dbName !== 'jpfire' && dbName !== 'qfpc'">
                        <td><strong>Client Defined Rating</strong></td>
                        <td>{{ doorCheckDoor.client_defined_rating }}</td>
                    </tr>
                    <tr>
                        <td><strong>Door Type</strong></td>
                        <td>{{ doorCheckDoor.door_type }}</td>
                    </tr>
                    <tr>
                        <td>
                            <strong v-if="dbName !== 'jpfire' && dbName !== 'qfpc'">Floor Level</strong>
                            <strong v-else>Door Location</strong>
                        </td>
                        <td>{{ doorCheckDoor.door_location }}</td>
                    </tr>
                    <tr v-if="!doorCheck.is_third_party_report">
                        <td><strong>Door Material</strong></td>
                        <td>{{ doorCheckDoor.door_material }}</td>
                    </tr>
                    <tr v-if="!doorCheck.is_third_party_report">
                        <td><strong>Frame Material</strong></td>
                        <td>{{ doorCheckDoor.frame_material }}</td>
                    </tr>
                    <tr v-if="dbName !== 'jpfire' && doorCheck.use_bm_trada_template">
                        <td><strong>Client Declared Resistance Level</strong></td>
                        <td>{{ doorCheckDoor.declared_resistance_level !== undefined ? doorCheckDoor.declared_resistance_level : '' }}</td>
                    </tr>
                    <tr v-if="dbName !== 'jpfire' && doorCheck.use_bm_trada_template && !doorCheck.is_third_party_report">
                        <td><strong>Level</strong></td>
                        <td>{{ doorCheckDoor.level !== undefined ? doorCheckDoor.level : '' }}</td>
                    </tr>
                    <tr v-if="dbName !== 'jpfire' && doorCheck.use_bm_trada_template && !doorCheck.is_third_party_report">
                        <td><strong>Plugs & Labels Present</strong></td>
                        <td>{{ (doorCheckDoor.plugs_labels_present !== undefined && doorCheckDoor.plugs_labels_present) ? 'Yes' : 'No' }}</td>
                    </tr>
                    <tr v-if="dbName !== 'jpfire' && doorCheck.use_bm_trada_template">
                        <td><strong>Test Evidence Available</strong></td>
                        <td>{{ (doorCheckDoor.test_evidence_available !== undefined && doorCheckDoor.test_evidence_available) ? 'Yes' : 'No' }}</td>
                    </tr>
                    <tr v-if="!doorCheck.is_third_party_report">
                        <td><strong>Dimensions</strong></td>
                        <td>{{ doorCheckDoor.dimensions }}</td>
                    </tr>
                    <tr v-if="!doorCheck.is_third_party_report">
                        <td><strong>Door Set</strong></td>
                        <td>{{ doorCheckDoor.door_set }}</td>
                    </tr>
                    <tr v-if="!doorCheck.is_third_party_report">
                        <td><strong>Glazing Panels?</strong></td>
                        <td>{{ doorCheckDoor.glazing_panels ? 'Yes' : 'No' }}</td>
                    </tr>
                    <tr v-if="doorCheckDoor.glazing_panels && !doorCheck.is_third_party_report">
                        <td><strong>Glazing Panels Number</strong></td>
                        <td>{{ doorCheckDoor.glazing_panels_number }}</td>
                    </tr>
                    <tr v-if="doorCheckDoor.glazing_panels && !doorCheck.is_third_party_report">
                        <td><strong>Glazing Panels Sizes</strong></td>
                        <td>{{ doorCheckDoor.glazing_panels_sizes }}</td>
                    </tr>
                    <tr v-if="dbName !== 'jpfire' && doorCheckDoor.glazing_panels && !doorCheck.is_third_party_report">
                        <td><strong>Glazing Panels Type</strong></td>
                        <td>{{ doorCheckDoor.glazing_panels_type }}</td>
                    </tr>
                    <tr v-if="!doorCheck.is_third_party_report">
                        <td><strong>Substrate Type</strong></td>
                        <td>{{ doorCheckDoor.substrate_type }}</td>
                    </tr>
                    <tr v-if="dbName !== 'jpfire' && dbName !== 'qfpc'">
                        <td><strong>Door Inspected By</strong></td>
                        <td>{{ doorCheckDoor.door_inspected_by !== undefined && doorCheckDoor.door_inspected_by ? doorCheckDoor.door_inspected_by : ''  }}</td>
                    </tr>
                    <tr v-if="doorCheckDoor.additional_inspector_notes && !doorCheck.is_third_party_report">
                        <td><strong>Additional Inspector Notes</strong></td>
                        <td>
                            <p>{{ doorCheckDoor.additional_inspector_notes }}</p>
                            <hr>
                            <small v-if="doorCheckDoor.include_inspector_notes_on_report"><em>These notes <strong>will</strong> be included in the report.</em></small>
                            <small v-else><em>These notes <strong>will not</strong> be included in the report.</em></small>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>

            <div class="widget" v-if="!doorCheck.is_third_party_report">
                <div class="widget-header bordered no-actions d-flex align-items-center">
                    <h3>
                        Pass Tests
                    </h3>
                </div>
                <div class="widget-body">
                    <table class="table table-condensed table-bordered ">
                        <thead>
                        <tr>
                            <th>Part</th>
                            <th>Status</th>
                            <th>Faults</th>
                            <th>Notes</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td><strong>Frame</strong></td>
                            <td>
                                <span v-bind:class="doorCheckDoor.frame_pass_status === 'Pass' ? 'c-positive' : (doorCheckDoor.frame_pass_status === 'Fail' ? 'c-negative' : 'c-neutral')">{{ doorCheckDoor.frame_pass_status }}</span>
                            </td>
                            <td>
                                <ul v-if="doorCheckDoor.frame_faults">
                                    <li v-for="fault in doorCheckDoor.frame_faults" v-bind:key="fault.door_fault_id"><strong>{{ fault.fault_code }}</strong> <span v-if="fault.fault_code && fault.fault_description" style="margin-left: 5px;">|</span> {{ fault.fault_description }}</li>
                                </ul>
                            </td>
                            <td>
                                <span v-if="doorCheckDoor.frame_pass_additional_comments">{{ doorCheckDoor.frame_pass_additional_comments }}</span>
                            </td>
                        </tr>
                        <tr>
                            <td><strong>Hinge</strong></td>
                            <td>
                                <span v-bind:class="doorCheckDoor.hinge_pass_status === 'Pass' ? 'c-positive' : (doorCheckDoor.hinge_pass_status === 'Fail' ? 'c-negative' : 'c-neutral')">{{ doorCheckDoor.hinge_pass_status }}</span>
                            </td>
                            <td>
                                <ul v-if="doorCheckDoor.hinge_faults">
                                    <li v-for="fault in doorCheckDoor.hinge_faults" v-bind:key="fault.door_fault_id"><strong>{{ fault.fault_code }}</strong> <span v-if="fault.fault_code && fault.fault_description" style="margin-left: 5px;">|</span> {{ fault.fault_description }}</li>
                                </ul>
                            </td>
                            <td>
                                <span v-if="doorCheckDoor.hinge_pass_additional_comments">{{ doorCheckDoor.hinge_pass_additional_comments }}</span>
                            </td>
                        </tr>
                        <tr>
                            <td><strong>Lock</strong></td>
                            <td>
                                <span v-bind:class="doorCheckDoor.lock_pass_status === 'Pass' ? 'c-positive' : (doorCheckDoor.lock_pass_status === 'Fail' ? 'c-negative' : 'c-neutral')">{{ doorCheckDoor.lock_pass_status }}</span>
                            </td>
                            <td>
                                <ul v-if="doorCheckDoor.lock_faults">
                                    <li v-for="fault in doorCheckDoor.lock_faults" v-bind:key="fault.door_fault_id"><strong>{{ fault.fault_code }}</strong> <span v-if="fault.fault_code && fault.fault_description" style="margin-left: 5px;">|</span> {{ fault.fault_description }}</li>
                                </ul>
                            </td>
                            <td>
                                <span v-if="doorCheckDoor.lock_pass_additional_comments">{{ doorCheckDoor.lock_pass_additional_comments }}</span>
                            </td>
                        </tr>
                        <tr>
                            <td><strong>Glass</strong></td>
                            <td>
                                <span v-bind:class="doorCheckDoor.glass_pass_status === 'Pass' ? 'c-positive' : (doorCheckDoor.glass_pass_status === 'Fail' ? 'c-negative' : 'c-neutral')">{{ doorCheckDoor.glass_pass_status }}</span>
                            </td>
                            <td>
                                <ul v-if="doorCheckDoor.glass_faults">
                                    <li v-for="fault in doorCheckDoor.glass_faults" v-bind:key="fault.door_fault_id"><strong>{{ fault.fault_code }}</strong> <span v-if="fault.fault_code && fault.fault_description" style="margin-left: 5px;">|</span> {{ fault.fault_description }}</li>
                                </ul>
                            </td>
                            <td>
                                <span v-if="doorCheckDoor.glass_pass_additional_comments">{{ doorCheckDoor.glass_pass_additional_comments }}</span>
                            </td>
                        </tr>
                        <tr>
                            <td><strong>Seals</strong></td>
                            <td>
                                <span v-bind:class="doorCheckDoor.seals_pass_status === 'Pass' ? 'c-positive' : (doorCheckDoor.seals_pass_status === 'Fail' ? 'c-negative' : 'c-neutral')">{{ doorCheckDoor.seals_pass_status }}</span>
                            </td>
                            <td>
                                <ul v-if="doorCheckDoor.seals_faults">
                                    <li v-for="fault in doorCheckDoor.seals_faults" v-bind:key="fault.door_fault_id"><strong>{{ fault.fault_code }}</strong> <span v-if="fault.fault_code && fault.fault_description" style="margin-left: 5px;">|</span> {{ fault.fault_description }}</li>
                                </ul>
                            </td>
                            <td>
                                <span v-if="doorCheckDoor.seals_pass_additional_comments">{{ doorCheckDoor.seals_pass_additional_comments }}</span>
                            </td>
                        </tr>
                        <tr>
                            <td><strong>Closer</strong></td>
                            <td>
                                <span v-bind:class="doorCheckDoor.closer_pass_status === 'Pass' ? 'c-positive' : (doorCheckDoor.closer_pass_status === 'Fail' ? 'c-negative' : 'c-neutral')">{{ doorCheckDoor.closer_pass_status }}</span>
                            </td>
                            <td>
                                <ul v-if="doorCheckDoor.closer_faults">
                                    <li v-for="fault in doorCheckDoor.closer_faults" v-bind:key="fault.door_fault_id"><strong>{{ fault.fault_code }}</strong> <span v-if="fault.fault_code && fault.fault_description" style="margin-left: 5px;">|</span> {{ fault.fault_description }}</li>
                                </ul>
                            </td>
                            <td>
                                <span v-if="doorCheckDoor.closer_pass_additional_comments">{{ doorCheckDoor.closer_pass_additional_comments }}</span>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <strong v-if="dbName !== 'jpfire' && dbName !== 'qfpc'">Leaf</strong>
                                <strong v-else>Structure</strong>
                            </td>
                            <td>
                                <span v-bind:class="doorCheckDoor.structure_pass_status === 'Pass' ? 'c-positive' : (doorCheckDoor.structure_pass_status === 'Fail' ? 'c-negative' : 'c-neutral')">{{ doorCheckDoor.structure_pass_status }}</span>
                            </td>
                            <td>
                                <ul v-if="doorCheckDoor.structure_faults">
                                    <li v-for="fault in doorCheckDoor.structure_faults" v-bind:key="fault.door_fault_id"><strong>{{ fault.fault_code }}</strong> <span v-if="fault.fault_code && fault.fault_description" style="margin-left: 5px;">|</span> {{ fault.fault_description }}</li>
                                </ul>
                            </td>
                            <td>
                                <span v-if="doorCheckDoor.structure_pass_additional_comments">{{ doorCheckDoor.structure_pass_additional_comments }}</span>
                            </td>
                        </tr>
                        <tr>
                            <td><strong>Signage</strong></td>
                            <td>
                                <span v-bind:class="doorCheckDoor.signage_pass_status === 'Pass' ? 'c-positive' : (doorCheckDoor.signage_pass_status === 'Fail' ? 'c-negative' : 'c-neutral')">{{ doorCheckDoor.signage_pass_status }}</span>
                            </td>
                            <td>
                                <ul v-if="doorCheckDoor.signage_faults">
                                    <li v-for="fault in doorCheckDoor.signage_faults" v-bind:key="fault.door_fault_id"><strong>{{ fault.fault_code }}</strong> <span v-if="fault.fault_code && fault.fault_description" style="margin-left: 5px;">|</span> {{ fault.fault_description }}</li>
                                </ul>
                            </td>
                            <td>
                                <span v-if="doorCheckDoor.signage_pass_additional_comments">{{ doorCheckDoor.signage_pass_additional_comments }}</span>
                            </td>
                        </tr>
                        <tr>
                            <td><strong>Gaps</strong></td>
                            <td>
                                <span v-bind:class="doorCheckDoor.gaps_pass_status === 'Pass' ? 'c-positive' : (doorCheckDoor.gaps_pass_status === 'Fail' ? 'c-negative' : 'c-neutral')">{{ doorCheckDoor.gaps_pass_status }}</span>
                            </td>
                            <td>
                                <ul v-if="doorCheckDoor.gaps_faults">
                                    <li v-for="fault in doorCheckDoor.gaps_faults" v-bind:key="fault.door_fault_id"><strong>{{ fault.fault_code }}</strong> <span v-if="fault.fault_code && fault.fault_description" style="margin-left: 5px;">|</span> {{ fault.fault_description }}</li>
                                </ul>
                            </td>
                            <td>
                                <span v-if="doorCheckDoor.gaps_pass_additional_comments">{{ doorCheckDoor.gaps_pass_additional_comments }}</span>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <div class="widget" v-if="!doorCheck.is_third_party_report">
                <div class="widget-header bordered no-actions d-flex align-items-center">
                    <h3>
                        Gaps Measurements
                    </h3>
                </div>
                <div class="widget-body">
                    <table class="table table-responsive table-condensed table-bordered">
                        <thead>
                            <tr>
                                <th>Gap Position</th>
                                <th>Head</th>
                                <th>Closing Edge (Single Leaf)</th>
                                <th>Meeting Edge (Double Leaf)</th>
                                <th>Hinge Edge #1</th>
                                <th>Hinge Edge #2</th>
                                <th>Sill</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <th>mm</th>
                                <td>
                                    {{ doorCheckDoor.gap_head }}
                                </td>
                                <td>
                                    {{ doorCheckDoor.gap_closing_edge }}
                                </td>
                                <td>
                                    {{ doorCheckDoor.gap_meeting_edge }}
                                </td>
                                <td>
                                    {{ doorCheckDoor.gap_hinge_edge_1 }}
                                </td>
                                <td>
                                    {{ doorCheckDoor.gap_hinge_edge_2 }}
                                </td>
                                <td>
                                    {{ doorCheckDoor.gap_still }}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <div v-if="dbName !== 'jpfire' && dbName !== 'qfpc' && (doorCheckDoor.door_status === 'Completion Report' || doorCheckDoor.door_status === 'Audited')">

                <div class="widget">
                    <div class="widget-header bordered no-actions d-flex align-items-center">
                        <h3>Installation Details</h3>
                    </div>
                    <div class="widget-body">
                        <table class="table table-bordered">
                            <tbody>
                            <tr>
                                <td><strong>Installation Date</strong></td>
                                <td>{{ doorCheckDoor.installation_date | formatDate }}</td>
                            </tr>
                            <tr>
                                <td><strong>Installed By</strong></td>
                                <td>{{ doorCheckDoor.installed_by }}</td>
                            </tr>
                            <tr>
                                <td><strong>Actioned Issues</strong></td>
                                <td>
                                    <ul v-if="doorCheckDoor.actioned_faults.length > 0">
                                        <li v-for="fault in doorCheckDoor.actioned_faults" v-bind:key="fault.door_check_door_fault_id"><strong>{{ fault.fault_code }}</strong> <span v-if="fault.fault_code && fault.fault_description" style="margin-left: 5px;">|</span> {{ fault.fault_description }}</li>
                                    </ul>
                                </td>
                            </tr>
                            <tr>
                                <td><strong>Comments</strong></td>
                                <td>
                                    <p>{{ doorCheckDoor.installation_comments }}</p>
                                </td>
                            </tr>
                            <tr v-if="doorCheckDoor.offline_engineer_signature_image == null">
                                <td><strong>Installer's Signature</strong></td>
                                <td>
                                    <span v-if="doorCheckDoor.engineer_signature_image == null">No signature found</span>
                                    <span v-else>Uploaded</span>
                                </td>
                            </tr>
                            <tr v-else>
                                <td><strong>Installer's Signature (offline)</strong></td>
                                <td>
                                    <img class="img-fluid" v-bind:src="doorCheckDoor.offline_engineer_signature_image.data">
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <div class="widget" v-if="postInstallationImages.length > 0">
                    <div class="widget-header bordered no-actions d-flex align-items-center">
                        <h3>Photos After Installation</h3>
                    </div>
                    <div class="widget-body">
                        <div class="row">

                            <door-check-door-image
                                    v-for="doorCheckDoorImage in postInstallationImages"
                                    v-bind:key="doorCheckDoorImage.door_check_door_image_id"
                                    v-bind:doorCheckDoorImage="doorCheckDoorImage"
                            ></door-check-door-image>

                        </div>
                    </div>
                </div>

                <div class="widget" v-if="offlinePostInstallationImages.length > 0">
                    <div class="widget-header bordered no-actions d-flex align-items-center">
                        <h3>Photos After Installation - Local Images</h3>
                    </div>
                    <div class="widget-body">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="alert alert-warning">
                                    <p class="mb-0 pb-0">Images in this section have not yet been synced with the server.</p>
                                </div>
                            </div>
                        </div>
                        <div class="row">

                            <template v-for="(offlineImage, index) in doorCheckDoor.offline_images">
                                <div class="col-sm-3 pb-3 entity-row-6"  style="margin-bottom: 10px;" v-bind:key="index" v-if="offlineImage.door_status === 'Completion Report'">
                                    <img v-bind:src="offlineImage.data" class="img-fluid">
                                    <div class="image-actions">
                                        <button v-on:click="rotatePhoto(index,-90)" :disabled="modifyingPhoto" class="btn btn-primary btn-xs btn-square" title="Rotate Anti-clockwise"><i class="fa fa-undo"></i></button>
                                        <button v-on:click="rotatePhoto(index,90)" :disabled="modifyingPhoto" class="btn btn-primary btn-xs btn-square" title="Rotate Clockwise"><i class="fa fa-undo fa-flip-horizontal"></i></button>
                                    </div>
                                    <button v-on:click="removePhoto(index)" :disabled="modifyingPhoto" class="btn btn-outline-danger btn-square mt-3 w-100">Remove Photo</button>
                                </div>
                            </template>

                        </div>
                    </div>
                </div>

            </div>

            <div v-if="dbName !== 'jpfire' && dbName !== 'qfpc' && doorCheckDoor.door_status === 'Audited'">
                <div class="widget">
                    <div class="widget-header bordered no-actions d-flex align-items-center">
                        <h3>Audit Details</h3>
                    </div>
                    <div class="widget-body">
                        <table class="table table-bordered">
                            <tbody>
                            <tr>
                                <td><strong>Audit Date</strong></td>
                                <td>{{ doorCheckDoor.audit_date | formatDate }}</td>
                            </tr>
                            <tr>
                                <td><strong>Audited By</strong></td>
                                <td>{{ doorCheckDoor.audited_by }}</td>
                            </tr>
                            <tr>
                                <td><strong>Comments</strong></td>
                                <td>
                                    <p>{{ doorCheckDoor.audit_comments }}</p>
                                </td>
                            </tr>
                            <tr v-if="doorCheckDoor.offline_sign_off_signature_image === null || doorCheckDoor.offline_sign_off_signature_image === undefined">
                                <td><strong>Sign-off Signature</strong></td>
                                <td>
                                    <span v-if="doorCheckDoor.sign_off_signature_image === null || doorCheckDoor.sign_off_signature_image === undefined">No signature found</span>
                                    <span v-else>Uploaded</span>
                                </td>
                            </tr>
                            <tr v-else>
                                <td><strong>Sign-off Signature (offline)</strong></td>
                                <td>
                                    <img class="img-fluid" v-bind:src="doorCheckDoor.offline_sign_off_signature_image.data">
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <div class="widget" v-if="auditImages.length > 0">
                    <div class="widget-header bordered no-actions d-flex align-items-center">
                        <h3>Audit Findings</h3>
                    </div>
                    <div class="widget-body">
                        <div class="row">

                            <door-check-door-image
                                    v-for="doorCheckDoorImage in auditImages"
                                    v-bind:key="doorCheckDoorImage.door_check_door_image_id"
                                    v-bind:doorCheckDoorImage="doorCheckDoorImage"
                            ></door-check-door-image>

                        </div>
                    </div>
                </div>

                <div class="widget" v-if="offlineAuditImages.length > 0">
                    <div class="widget-header bordered no-actions d-flex align-items-center">
                        <h3>Audit Findings - Local Images</h3>
                    </div>
                    <div class="widget-body">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="alert alert-warning">
                                    <p class="mb-0 pb-0">Images in this section have not yet been synced with the server.</p>
                                </div>
                            </div>
                        </div>
                        <div class="row">

                            <template v-for="(offlineImage, index) in doorCheckDoor.offline_images">
                                <div class="col-sm-3 pb-3 entity-row-6"  style="margin-bottom: 10px;" v-bind:key="index" v-if="offlineImage.door_status === 'Audited'">
                                    <img v-bind:src="offlineImage.data" class="img-fluid">
                                    <div class="image-actions">
                                        <button v-on:click="rotatePhoto(index,-90)" :disabled="modifyingPhoto" class="btn btn-primary btn-xs btn-square" title="Rotate Anti-clockwise"><i class="fa fa-undo"></i></button>
                                        <button v-on:click="rotatePhoto(index,90)" :disabled="modifyingPhoto" class="btn btn-primary btn-xs btn-square" title="Rotate Clockwise"><i class="fa fa-undo fa-flip-horizontal"></i></button>
                                    </div>
                                    <button v-on:click="removePhoto(index)" :disabled="modifyingPhoto" class="btn btn-outline-danger btn-square mt-3 w-100">Remove Photo</button>
                                </div>
                            </template>

                        </div>
                    </div>
                </div>
            </div>

            


            <div class="widget" v-if="surveyImages.length > 0">
                <div class="widget-header bordered no-actions d-flex align-items-center">
                    <h3>
                        Images        </h3>
                </div>
                <div class="widget-body">
                    <div class="row">

                        <door-check-door-image
                                v-for="doorCheckDoorImage in surveyImages"
                                v-bind:key="doorCheckDoorImage.door_check_door_image_id"
                                v-bind:doorCheckDoorImage="doorCheckDoorImage"
                        ></door-check-door-image>

                    </div>
                </div>
            </div>

            <div class="widget" v-if="offlineSurveyImages.length > 0">
                <div class="widget-header bordered no-actions d-flex align-items-center">
                    <h3>Local Images</h3>
                </div>
                <div class="widget-body">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="alert alert-warning">
                                <p class="mb-0 pb-0">Images in this section have not yet been synced with the server.</p>
                            </div>
                        </div>
                    </div>
                    <div class="row">

                        <template v-for="(offlineImage, index) in doorCheckDoor.offline_images">
                            <div class="col-sm-3 pb-3 entity-row-6" style="margin-bottom: 10px;" v-if="offlineImage.door_status !== 'Completion Report' && offlineImage.door_status !== 'Audited'">
                                <img v-bind:src="offlineImage.data" class="img-fluid">
                                <div class="image-actions">
                                    <button v-on:click="rotatePhoto(index,-90)" :disabled="modifyingPhoto" class="btn btn-primary btn-xs btn-square" title="Rotate Anti-clockwise"><i class="fa fa-undo"></i></button>
                                    <button v-on:click="rotatePhoto(index,90)" :disabled="modifyingPhoto" class="btn btn-primary btn-xs btn-square" title="Rotate Clockwise"><i class="fa fa-undo fa-flip-horizontal"></i></button>
                                </div>
                                <button v-on:click="removePhoto(index)" :disabled="modifyingPhoto" class="btn btn-outline-danger btn-square mt-3 w-100">Remove Photo</button>
                            </div>
                        </template>

                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-xl-12 col-md-12 col-sm-12">
                    <div class="widget has-shadow">
                        <div class="widget-body border-bottom">
                            <router-link :to="{ name: 'door-check-add-door', params: {id: doorCheckDoor.door_check.site_door_check_id} }" class="btn btn-outline-primary btn-square pt-3 pb-3 mt-3 mb-3" style="display:block;width:100%">
                                Add Another Door
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>

    import SitePlanMarkerView from '../components/SitePlanMarkerView.vue';
    import DoorCheckDoorImage from '@/components/DoorCheckDoorImage.vue'
    import ImageRotate from '@/components/mixins/ImageRotate.js'

    export default {
        components: {
            DoorCheckDoorImage,
            SitePlanMarkerView
        },
        mixins: [ImageRotate],
        data() {
            return {
                retryGetDoorCheckDoorCount: 0,
                retryGetDoorCheckCount: 0,
                sitePlan: null,
                doorCheckDoor: null,
                doorCheckDoorFound: false,
                doorCheckDoorLoading: true,
                doorCheck: {
                    door_check_id: null,
                    document_id: 'Loading...',
                    document_title: 'Please wait...',
                    site_door_check_id: null,
                },
                postInstallationImages: [],
                auditImages: [],
                surveyImages: [],
                modifyingPhoto: false
            }
        },
        methods: {
            getSitePlan() {
                var vm = this;
                this.getDb(function onConnected(db) {
                try {
                    var objectStore = db.transaction('door_check_site_plans').objectStore('door_check_site_plans');
                    var storeRequest = objectStore.get(parseInt(vm.doorCheckDoor.site_door_check_site_plan_id));

                    storeRequest.onsuccess = function(event) {
                    if (storeRequest.result !== undefined) {
                        vm.sitePlan = storeRequest.result;
                        vm.loadImages();
                    } else {
                        vm.doorCheckDoor = null;
                        vm.doorCheckDoorFound = false;
                        vm.doorCheckDoorLoading = false;
                    }
                    };
                    storeRequest.onerror = function(e) {
                        vm.doorCheckDoor = null;
                        vm.doorCheckDoorFound = false;
                        vm.doorCheckDoorLoading = false;
                    }
                } catch (e) {
                    console.log(e);
                }
                })
            },
            loadImages() {
                if(this.doorCheckDoor.door_check_door_images !== null && this.doorCheckDoor.door_check_door_images !== undefined) {
                    this.doorCheckDoor.door_check_door_images.forEach(item => {
                        if(item.door_status === 'Completion Report') {
                            this.postInstallationImages.push(item);
                        } else if(item.door_status === 'Audited') {
                            this.auditImages.push(item);
                        } else {
                            this.surveyImages.push(item);
                        }
                    });
                }
                this.doorCheckDoorFound = true;
                this.doorCheckDoorLoading = false;
            },
            getDoorCheckDoor() {
                var vm = this;
                this.getDb(function onConnectedGetDoorSets(db) {
                    try {
                        var doorCheckDoorId = parseInt(vm.$route.params.id);
                        var objectStore = db.transaction('door_check_doors').objectStore('door_check_doors');
                        var storeRequest = objectStore.get(doorCheckDoorId);
                        storeRequest.onsuccess = function(event) {
                            vm.doorCheckDoor = storeRequest.result;
                            if (storeRequest.result !== undefined) {
                                vm.getDoorCheck();
                                vm.doorCheckDoorFound = true;
                                vm.site_door_check_id = storeRequest.result.door_check.site_door_check_id;
                            } else {
                            }
                            vm.doorCheckDoorLoading = false;
                        };
                        storeRequest.onerror = function(e) {
                            vm.doorCheckDoorFound = false;
                            vm.doorCheckDoorLoading = false;
                        }
                    } catch (e) {
                        console.log(e);
                    }
                })
            },
            getDoorCheck() {
                var vmt = this;
                this.getDb(function onConnectedGetDoorSets(db) {

                    var vm = vmt;
                    try {
                        var doorCheckId = vm.doorCheckDoor.site_door_check_id;
                        var objectStore = db.transaction('door_checks').objectStore('door_checks');
                        var storeRequest = objectStore.get(doorCheckId);
                        storeRequest.onsuccess = function(event) {
                            vm.doorCheck = storeRequest.result;
                            if (storeRequest.result !== undefined) {
                                vm.doorCheckDoor.site_door_check_id = vm.doorCheck.site_door_check_id;
                                vm.doorCheckFound = true;
                                if(vm.doorCheckDoor.site_door_check_site_plan_id) {
                                    vm.getSitePlan();
                                } else {
                                    vm.loadImages();
                                }
                            }
                            vm.doorCheckLoading = false;
                        };
                        storeRequest.onerror = function(e) {
                            vm.doorCheckFound = false;
                            vm.doorCheckLoading = false;
                        }
                    } catch (e) {
                        console.log(e);
                    }

                })
            },
            getDoorCheckDoorData() {
                return {
                    additional_inspector_notes: this.doorCheckDoor.additional_inspector_notes,
                    any_faults: [],
                    barcode: this.doorCheckDoor.barcode,
                    closer_faults: this.doorCheckDoor.closer_faults,
                    closer_pass_additional_comments: this.doorCheckDoor.closer_pass_additional_comments,
                    closer_pass_status: this.doorCheckDoor.closer_pass_status,
                    dimensions: this.doorCheckDoor.dimensions,
                    door_check: {site_door_check_id: vm.doorCheck.site_door_check_id},
                    door_check_door_images: this.doorCheckDoor.door_check_door_images,
                    door_check_door_id: this.doorCheckDoor.door_check_door_id,
                    door_check_id: vm.doorCheck.door_check_id,
                    site_door_check_site_plan_id: this.doorCheckDoor.site_door_check_site_plan_id !== undefined ? this.doorCheckDoor.site_door_check_site_plan_id : null,
                    door_check_site_plan_id: this.doorCheckDoor.door_check_site_plan_id !== undefined ? this.doorCheckDoor.door_check_site_plan_id : null,
                    site_plan_image_position_x: this.doorCheckDoor.site_plan_image_position_x !== undefined ? this.doorCheckDoor.site_plan_image_position_x : null,
                    site_plan_image_position_y: this.doorCheckDoor.site_plan_image_position_y !== undefined ? this.doorCheckDoor.site_plan_image_position_y : null,
                    site_plan_image_zoom_level: this.doorCheckDoor.site_plan_image_zoom_level !== undefined ? this.doorCheckDoor.site_plan_image_zoom_level : null,
                    pin_number: this.doorCheckDoor.pin_number !== undefined ? this.doorCheckDoor.pin_number : null,
                    door_id: this.doorCheckDoor.door_id,
                    door_location: this.doorCheckDoor.door_location,
                    glazing_panels: this.doorCheckDoor.glazing_panels !== undefined ? this.doorCheckDoor.glazing_panels : false,
                    glazing_panels_number: this.doorCheckDoor.glazing_panels_number !== undefined ? this.doorCheckDoor.glazing_panels_number : null,
                    glazing_panels_sizes: this.doorCheckDoor.glazing_panels_sizes !== undefined ? this.doorCheckDoor.glazing_panels_sizes : null,
                    glazing_panels_type: this.doorCheckDoor.glazing_panels_type !== undefined ? this.doorCheckDoor.glazing_panels_type : null,
                    substrate_type: this.doorCheckDoor.substrate_type !== undefined ? this.doorCheckDoor.substrate_type : null,
                    gap_head: this.doorCheckDoor.gap_head !== undefined ? this.doorCheckDoor.gap_head : null,
                    gap_closing_edge: this.doorCheckDoor.gap_closing_edge !== undefined ? this.doorCheckDoor.gap_closing_edge : null,
                    gap_meeting_edge: this.doorCheckDoor.gap_meeting_edge !== undefined ? this.doorCheckDoor.gap_meeting_edge : null,
                    gap_hinge_edge_1: this.doorCheckDoor.gap_hinge_edge_1 !== undefined ? this.doorCheckDoor.gap_hinge_edge_1 : null,
                    gap_hinge_edge_2: this.doorCheckDoor.gap_hinge_edge_2 !== undefined ? this.doorCheckDoor.gap_hinge_edge_2 : null,
                    gap_still: this.doorCheckDoor.gap_still !== undefined ? this.doorCheckDoor.gap_still : null,
                    door_material: this.doorCheckDoor.door_material,
                    door_set: this.doorCheckDoor.door_set,
                    door_type: this.doorCheckDoor.door_type,
                    client_defined_rating: this.doorCheckDoor.client_defined_rating !== undefined ? this.doorCheckDoor.client_defined_rating : null,
                    frame_faults: this.doorCheckDoor.frame_faults,
                    frame_material: this.doorCheckDoor.frame_material,
                    frame_pass_additional_comments: this.doorCheckDoor.frame_pass_additional_comments,
                    frame_pass_status: this.doorCheckDoor.frame_pass_status,
                    gaps_faults: this.doorCheckDoor.gaps_faults,
                    gaps_pass_additional_comments: this.doorCheckDoor.gaps_pass_additional_comments,
                    gaps_pass_status: this.doorCheckDoor.gaps_pass_status,
                    glass_faults: this.doorCheckDoor.glass_faults,
                    glass_pass_additional_comments: this.doorCheckDoor.glass_pass_additional_comments,
                    glass_pass_status: this.doorCheckDoor.glass_pass_status,
                    hinge_faults: this.doorCheckDoor.hinge_faults,
                    hinge_pass_additional_comments: this.doorCheckDoor.hinge_pass_additional_comments,
                    hinge_pass_status: this.doorCheckDoor.hinge_pass_status,
                    include_inspector_notes_on_report: this.doorCheckDoor.include_inspector_notes_on_report,
                    lock_faults: this.doorCheckDoor.lock_faults,
                    lock_pass_additional_comments: this.doorCheckDoor.lock_pass_additional_comments,
                    lock_pass_status: this.doorCheckDoor.lock_pass_status,
                    seals_faults: this.doorCheckDoor.seals_faults,
                    seals_pass_additional_comments: this.doorCheckDoor.seals_pass_additional_comments,
                    seals_pass_status: this.doorCheckDoor.seals_pass_status,
                    signage_faults: this.doorCheckDoor.signage_faults,
                    signage_pass_additional_comments: this.doorCheckDoor.signage_pass_additional_comments,
                    signage_pass_status: this.doorCheckDoor.signage_pass_status,
                    site_door_check_door_id: this.doorCheckDoor.site_door_check_door_id,
                    site_door_check_id: this.doorCheckDoor.site_door_check_id,
                    structure_faults: this.doorCheckDoor.structure_faults,
                    structure_pass_additional_comments: this.doorCheckDoor.structure_pass_additional_comments,
                    structure_pass_status: this.doorCheckDoor.structure_pass_status,
                    declared_resistance_level: this.doorCheckDoor.declared_resistance_level !== undefined ? this.doorCheckDoor.declared_resistance_level : null,
                    level: this.doorCheckDoor.level !== undefined ? this.doorCheckDoor.level : null,
                    plugs_labels_present: this.doorCheckDoor.plugs_labels_present !== undefined ? this.doorCheckDoor.plugs_labels_present : false,
                    test_evidence_available: this.doorCheckDoor.test_evidence_available !== undefined ? this.doorCheckDoor.test_evidence_available : false,
                    door_status: this.doorCheckDoor.door_status !== undefined ? this.doorCheckDoor.door_status : null,
                    installation_date: this.doorCheckDoor.installation_date !== undefined ? this.doorCheckDoor.installation_date : null,
                    installation_comments: this.doorCheckDoor.installation_comments !== undefined ? this.doorCheckDoor.installation_comments : null,
                    installed_by: this.doorCheckDoor.installed_by !== undefined ? this.doorCheckDoor.installed_by : null,
                    engineer_signature_image: this.doorCheckDoor.engineer_signature_image !== undefined ? this.doorCheckDoor.engineer_signature_image : null,
                    audit_date: this.doorCheckDoor.audit_date !== undefined ? this.doorCheckDoor.audit_date : null,
                    audit_comments: this.doorCheckDoor.audit_comments !== undefined ? this.doorCheckDoor.audit_comments : null,
                    audited_by: this.doorCheckDoor.audited_by !== undefined ? this.doorCheckDoor.audited_by : null,
                    sign_off_signature_image: this.doorCheckDoor.sign_off_signature_image !== undefined ? this.doorCheckDoor.sign_off_signature_image : null,
                    offline_images: this.doorCheckDoor.offline_images,
                    actioned_faults: this.doorCheckDoor.actioned_faults !== undefined ? this.doorCheckDoor.actioned_faults : [],
                    user_id: this.$session.get('user_id'),
                    offline_engineer_signature_image: this.doorCheckDoor.offline_engineer_signature_image !== undefined ? this.doorCheckDoor.offline_engineer_signature_image : null,
                    offline_sign_off_signature_image: this.doorCheckDoor.offline_sign_off_signature_image !== undefined ? this.doorCheckDoor.offline_sign_off_signature_image : null
                };
            },
            removePhoto(index) {
                this.modifyingPhoto = true;
                this.doorCheckDoor.offline_images.splice(index, 1);
                var vm = this;
                this.getDb(function onConnectedGetDoorSets(db) {
                    var putRequest = db.transaction('door_check_doors', 'readwrite')
                        .objectStore('door_check_doors').put(vm.getDoorCheckDoorData());
                    putRequest.onsuccess = function(event) {
                        vm.modifyingPhoto = false;
                    };
                    putRequest.onerror = function(event) {
                        alert("Unable to remove photo");
                        window.location = '';
                    };
                });
            },
            rotatePhoto(index, degrees) {
                this.modifyingPhoto = true;
                this.rotateImage(this.doorCheckDoor.offline_images[index].data, degrees).then(newDataUri => {
                    this.doorCheckDoor.offline_images[index].data = newDataUri;

                    var vm = this;
                    this.getDb(function onConnectedGetDoorSets(db) {
                        var putRequest = db.transaction('door_check_doors', 'readwrite')
                            .objectStore('door_check_doors').put(vm.getDoorCheckDoorData());
                        putRequest.onsuccess = function(event) {
                            vm.modifyingPhoto = false;
                        };
                        putRequest.onerror = function(event) {
                            alert("Unable to rotate photo");
                            window.location = '';
                        };
                    });
                }).catch(e => {
                    console.log(e);
                    alert('Error occurred while trying to rotate photo');
                    this.modifyingPhoto = false;
                });
            },
        },
        mounted () {
            const modulesData = this.$session.get('enabled_modules');
            if(!modulesData || modulesData.indexOf('FDR') === -1) {
                this.$router.push('/');
                return;
            }
            this.getDoorCheckDoor();
        },
        computed: {
            markerData() {
                return {
                    position_x: this.doorCheckDoor.site_plan_image_position_x,
                    position_y: this.doorCheckDoor.site_plan_image_position_y,
                    marker_number: this.doorCheckDoor.pin_number,
                    img_src: this.sitePlan.offline_site_plan_image ? this.sitePlan.offline_site_plan_image.data : (this.cmsUrl + this.sitePlan.site_plan_image)
                }; 
            },
            offlinePostInstallationImages() {
                var imgs = [];
                this.doorCheckDoor.offline_images.forEach(item => {
                    if(item.door_status === 'Completion Report') {
                        imgs.push(item);
                    }
                });
                return imgs;
            },
            offlineAuditImages() {
                var imgs = [];
                this.doorCheckDoor.offline_images.forEach(item => {
                    if(item.door_status === 'Audited') {
                        imgs.push(item);
                    }
                });
                return imgs;
            },
            offlineSurveyImages() {
                var imgs = [];
                this.doorCheckDoor.offline_images.forEach(item => {
                    if(item.door_status !== 'Completion Report' && item.door_status !== 'Audited') {
                        imgs.push(item);
                    }
                });
                return imgs;
            }
        }
    }
</script>